module.exports = __webpack_public_path__ + "img/Tessellate49.657b3181.jpg";